import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AnimationOptions} from 'ngx-lottie';

import {GlobalQuestionService} from '../../services/global-question.service';
import {Router} from '@angular/router';
import {DatePipe} from '@angular/common';

import {Subject, Subscription} from 'rxjs';
import {UserStore} from '../../../authentication/state/user.store';
import {EntryType, QuestionType, RouterLinks} from '../../constants';

import {debounceTime} from 'rxjs/operators';
import {QuestionFlowSessionStore} from '../../questions/state/question-flow-session.store';
import { forEach } from 'lodash';
import { FlowPlayerService } from '../../services/flow-player.service';
import { QuestionFlowSessionQuery } from '../../questions/state/question-flow-session.query';
import { Alert } from '../../utilities';

declare const accounting: any;
declare const $: any;

declare function notify(): any;

declare function editModalGuides(): any;

enum DisplayItem {
  PolicyHolderDetails = 'PolicyHolderDetails',
  PaymentDetails = 'PaymentDetails',
  ClassItems = 'ClassItems',
  BenefitItems = 'BenefitItems'
}

enum Entity {
  Policy = 'Policy',
  Item = 'Item',
  Vap = 'Vap'
}

@Component({
    selector: 'app-commercial-add-location',
    templateUrl: './commercial-add-location.component.html',
    styleUrls: ['./commercial-add-location.component.scss'],
    standalone: false
})
export class CommercialAddLocationComponent implements OnInit, AfterViewInit, OnDestroy {

 person: any;
 accounting: any;
 notify: any;
  lottieOptions: AnimationOptions = {
    path: 'assets/everything-insure-loader.json',
  };
  questionChanged = new Subject<any>();
  selectedLocation: any;
  selectedClass: any;
  locations: any;
  classes: any;
 questions: any = [];
 grouping: any;
 responses: any = [];
 session_details: any;
 isEditMode: boolean = false;
  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private flowPlayer: FlowPlayerService,
    private questionFlowSessionStore: QuestionFlowSessionStore,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
    private userStore: UserStore,
    public questionService: GlobalQuestionService) {
    accounting.settings = {
      currency: {
        symbol: 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      }
    };
    this.accounting = accounting;
    this.notify = notify();

    if (this.router.getCurrentNavigation()?.extras?.state) {
      this.locations = this.router.getCurrentNavigation()?.extras?.state?.locations;
      this.selectedLocation = this.router.getCurrentNavigation()?.extras?.state?.location;
      this.isEditMode = this.router.getCurrentNavigation()?.extras?.state?.edit;
      
    }else{
      this.router.navigate([RouterLinks.QuestionFlow])
    }
    
  }

  ngOnInit(): void {
    this.person = this.userStore.getValue();
    this.questionService.spinner(true);
    this.session_details = this.questionFlowSessionQuery.getValue();
    let item_id = '0'
    let location_id = 0;
    if (this.isEditMode) {
      item_id = this.selectedLocation?.location_id;
      location_id = this.selectedLocation?.location_id;
      //this.flowPlayer.startFlow(this.session_details?.superflow_id, 63, this.session_details.category_id, this.session_details.group_id, item_id, this.session_details.session_id, this.session_details.css, 0);
      this.flowPlayer.flowQuestions(63, this.session_details.category_id, this.session_details.session_id, this.session_details.group_id, location_id, null, null, location_id)
        .subscribe((val: any[]) => {
          if (!val?.length) {
            return;
          }
          this.questions = val;
          console.log(this.questions);
          this.questionService.spinner(false);
        })
    }
    else {
      const parameters = new Map<string, string>();
      parameters.set('session_id', this.session_details?.session_id);
      parameters.set('class_id', "0");
      parameters.set('question_id', "1991");
      parameters.set('flow_id', "64");
      this.questionService.runCommandNew(`setNewLocationDetails`, parameters)
        .subscribe(questions => {
          this.questions = questions;
          this.questionService.spinner(false);
        }, error => {
          this.questionService.spinner(false);
          $('#error-modal').modal('show');
        })
    }
    
   
   
  }

  ngAfterViewInit(): void {
   
  }
  addLocation(): void{
    if(this.isEditMode){
      Alert('Location updated successfully.');
    }
    else{
      Alert('Location added successfully.');
    }
    
    setTimeout(() => {
      this.router.navigate([RouterLinks.QuestionFlow]);
    }, 3000);
 
  }
  questionResponse(event): void {
    this.responses.push(event)
  }
  getItemChildrenQuestions(question: any): any[] {
    return this.questions.filter(x => x?.parent_control === question?.cent_aq_question_id);
  }
  getBusinessName(): string {
    return this.questions.find(x => x?.cent_aq_question_id === 1222)?.question_copy;
  }
  removeLocation(): void{
    if (!this.isEditMode) {
      const parameters = new Map<string, string>();
      parameters.set('session_id', this.session_details?.session_id);
      parameters.set('item_id', this.questions[0]?.item_id);
      parameters.set('location_id', this.questions[0]?.location_id);
      this.questionService.runCommandNew(`removeLocation`, parameters)
        .subscribe(result => {
          this.router.navigate([RouterLinks.QuestionFlow]);
        }, error => {
          this.questionService.spinner(false);
          $('#error-modal').modal('show');
        })
    }
    else{
      this.router.navigate([RouterLinks.QuestionFlow]);
    }
   
  }
  ngOnDestroy(): void {
    //this.getPolicySubscription.unsubscribe();
  }

}
